module.exports = __webpack_public_path__ + "img/Ansar.499131f6.svg";